import AbstractCharacteristicValue from '@/domains/Abstract/AbstractCharacteristicValue';
import Utils                       from '@/core/utils/Utils';
import NumericRange                from '@/core/types/NumericRange';
import type Characteristic from "@/domains/Characteristics/Characteristic";

/**
 * Значение характеристики у товара. Конкретизация рамки —
 * numeric как NumericRange (диапазон), listValue как массив id.
 */
export default class ProductCharacteristic extends AbstractCharacteristicValue {
	numericValue: NumericRange;
	productId: number;

	static fromServer(data: any, productCharacteristic = new ProductCharacteristic()): ProductCharacteristic {
		super.fromServer(data, productCharacteristic);

		productCharacteristic.numericValue = Utils.hydrate(data.numericValue, NumericRange.fromServer) ?? new NumericRange();

		return productCharacteristic;
	}

	static fromCharacteristic(data: Characteristic, productCharacteristic = new ProductCharacteristic()): ProductCharacteristic {
		super.fromCharacteristic(data, productCharacteristic);

		productCharacteristic.numericValue = new NumericRange();

		return productCharacteristic;
	}

	getNumericValue(): NumericRange | undefined {
		return this.numericValue;
	}

	setNumericValue(value: unknown): void {
		this.numericValue = value as NumericRange ?? null;
	}
}
